/* ============================================================
   KILLABRUSH™ — THEME JAVASCRIPT
   ============================================================ */

(function () {
  'use strict';

  /* ---- Free-shipping thresholds ----
     UK/GBP only — free shipping is not offered in other markets.
     In minor units (pence). MUST match Shopify Admin → Shipping profiles.
     Keep in sync with the same logic in main-cart.liquid. */
  var KB_FREE_SHIPPING = {
    GBP: 4000   // £40
  };

  /* ---- Sticky Header ---- */
  const header = document.querySelector('.kb-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ---- Mobile Nav ---- */
  const hamburger = document.querySelector('.kb-hamburger');
  const mobileNav = document.querySelector('.kb-mobile-nav');
  const mobileClose = document.querySelector('.kb-mobile-nav__close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });

    const closeNav = () => {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    };

    if (mobileClose) mobileClose.addEventListener('click', closeNav);

    mobileNav.addEventListener('click', (e) => {
      if (e.target === mobileNav) closeNav();
    });
  }

  /* ---- Scroll Reveal ---- */
  const reveals = document.querySelectorAll('.kb-reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(el => observer.observe(el));
  }

  /* ---- Bacterial Chart Animate ---- */
  const chartRows = document.querySelectorAll('.kb-bacterial-row__bar');
  if (chartRows.length && 'IntersectionObserver' in window) {
    const chartObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const bar = entry.target;
          const width = bar.dataset.width || '0';
          bar.style.width = width + '%';
          chartObs.unobserve(bar);
        }
      });
    }, { threshold: 0.5 });

    chartRows.forEach(bar => {
      const width = bar.style.width;
      bar.dataset.width = parseInt(width) || 0;
      bar.style.width = '0';
      chartObs.observe(bar);
    });
  }

  /* ---- Accordion ---- */
  const accordionHeaders = document.querySelectorAll('.kb-accordion__header');
  accordionHeaders.forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.kb-accordion__item');
      const isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.kb-accordion__item.open').forEach(el => {
        el.classList.remove('open');
      });

      if (!isOpen) item.classList.add('open');
    });
  });

  /* ---- PDP Gallery ---- */
  const galleryMain = document.querySelector('.kb-gallery__main img');
  const thumbs = document.querySelectorAll('.kb-gallery__thumb');

  if (galleryMain && thumbs.length) {
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        const img = thumb.querySelector('img');
        if (img) {
          galleryMain.src = img.src;
          galleryMain.alt = img.alt;
        }
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });

      if (i === 0) thumb.classList.add('active');
    });
  }

  /* ---- Quantity Buttons ---- */
  document.querySelectorAll('.kb-quantity').forEach(widget => {
    const input = widget.querySelector('.kb-quantity__input');
    const minusBtn = widget.querySelector('[data-qty="minus"]');
    const plusBtn = widget.querySelector('[data-qty="plus"]');

    if (!input) return;

    if (minusBtn) {
      minusBtn.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
        input.dispatchEvent(new Event('change'));
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      });
    }
  });

  /* ---- Variant Selector ---- */
  document.querySelectorAll('.kb-variant-option').forEach(opt => {
    opt.addEventListener('click', () => {
      const group = opt.closest('.kb-variant-options');
      if (group) {
        group.querySelectorAll('.kb-variant-option').forEach(o => o.classList.remove('selected'));
      }
      opt.classList.add('selected');

      // Update hidden select for Shopify variant
      const variantId = opt.dataset.variantId;
      const hiddenSelect = document.querySelector('[name="id"]');
      if (hiddenSelect && variantId) {
        hiddenSelect.value = variantId;

        // Update price display
        const price = opt.dataset.price;
        const comparePrice = opt.dataset.comparePrice;
        const priceEl = document.querySelector('.kb-pdp__price-current');
        const comparePriceEl = document.querySelector('.kb-pdp__price-compare');
        if (priceEl && price) priceEl.textContent = price;
        if (comparePriceEl && comparePrice) {
          comparePriceEl.textContent = comparePrice;
          comparePriceEl.style.display = comparePrice ? '' : 'none';
        }
      }
    });
  });

  /* ---- Add to Cart (AJAX) ---- */
  const atcForm = document.querySelector('.kb-atc-form');
  if (atcForm) {
    atcForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = atcForm.querySelector('.kb-atc-btn');
      const originalText = btn.textContent;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        const formData = new FormData(atcForm);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          btn.textContent = 'Added ✓';

          // Update cart count and open drawer if enabled
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          updateCartCount(cart.item_count);

          if ((document.body.dataset.cartType || 'drawer') === 'drawer') {
            CartDrawer.itemsEl.innerHTML = '';
            CartDrawer.renderItems(cart);
            CartDrawer.renderFooter(cart);
            if (CartDrawer.countEl) {
              CartDrawer.countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
            }
            CartDrawer.open();
          } else {
            showFlash('Added to cart');
          }

          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        } else {
          throw new Error('Add to cart failed');
        }
      } catch (err) {
        btn.textContent = 'Try Again';
        btn.disabled = false;
        showFlash('Could not add to cart');
      }
    });
  }

  /* ---- Cart: Quantity Update ---- */
  document.querySelectorAll('.kb-cart-qty-input').forEach(input => {
    input.addEventListener('change', debounce(async () => {
      const key = input.dataset.key;
      const qty = parseInt(input.value);
      if (!key) return;

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        if (res.ok) {
          location.reload();
        }
      } catch (e) {
        console.error(e);
      }
    }, 600));
  });

  /* ---- Cart: Remove Item ---- */
  document.querySelectorAll('.kb-cart-item__remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      if (!key) return;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        if (res.ok) location.reload();
      } catch (e) {
        console.error(e);
      }
    });
  });

  /* ---- Flash Notification ---- */
  function showFlash(message) {
    let flash = document.querySelector('.kb-flash');
    if (!flash) {
      flash = document.createElement('div');
      flash.className = 'kb-flash';
      document.body.appendChild(flash);
    }
    flash.textContent = message;
    flash.classList.add('show');
    setTimeout(() => flash.classList.remove('show'), 3000);
  }

  /* ---- Cart Count ---- */
  function updateCartCount(count) {
    const counters = document.querySelectorAll('.kb-cart-count');
    counters.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  /* ---- Fetch Cart on Load ---- */
  (async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartCount(cart.item_count);
    } catch (e) {}
  })();

  /* ---- Locale Flags (country/currency switchers) ----
     ISO country code → emoji flag. Applied to any select marked
     data-locale-select (each option's value must be the 2-letter
     ISO code) and any span marked data-locale-flag containing the
     current ISO code. Windows desktop degrades to letter pairs;
     iOS/Android render true flags. */
  function isoToFlag(iso) {
    return String.fromCodePoint.apply(null,
      iso.toUpperCase().split('').map(function (c) {
        return 0x1F1E6 + c.charCodeAt(0) - 65;
      })
    );
  }

  document.querySelectorAll('[data-locale-select]').forEach(sel => {
    Array.from(sel.options).forEach(o => {
      if (o.value && o.value.length === 2 && !o.dataset.flagged) {
        o.dataset.flagged = '1';
        o.textContent = isoToFlag(o.value) + '  ' + o.textContent.trim();
      }
    });
  });

  document.querySelectorAll('[data-locale-flag]').forEach(el => {
    const code = el.textContent.trim();
    if (code.length === 2) el.textContent = isoToFlag(code);
  });

  /* ---- Newsletter Form ---- */
  const newsletterForm = document.querySelector('.kb-newsletter__form-el');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const emailInput = newsletterForm.querySelector('input[type="email"]');
      const btn = newsletterForm.querySelector('button');
      if (!emailInput || !emailInput.value) return;

      btn.textContent = 'Done ✓';
      emailInput.disabled = true;
      btn.disabled = true;
      showFlash('Thanks for registering interest!');
    });
  }

  /* ---- Utility: Debounce ---- */
  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  /* ---- Cart Drawer ---- */
  const CartDrawer = {
    el:       null,
    itemsEl:  null,
    footerEl: null,
    countEl:  null,
    isOpen:   false,

    init() {
      const cartType = document.body.dataset.cartType || 'drawer';
      if (cartType !== 'drawer') return;

      // Build drawer DOM dynamically (keeps theme.liquid clean)
      if (!document.getElementById('CartDrawer')) {
        document.body.insertAdjacentHTML('afterbegin', "<div id=\"CartDrawer\" class=\"kb-cart-drawer\"><div class=\"kb-cart-drawer__overlay\"></div><div class=\"kb-cart-drawer__panel\"><div class=\"kb-cart-drawer__header\"><div><span class=\"kb-cart-drawer__eyebrow\">Your Selection</span><h2 class=\"kb-cart-drawer__title\">Your Bag <span class=\"kb-cart-drawer__count\"></span></h2></div><button class=\"kb-cart-drawer__close\" aria-label=\"Close cart\"><svg width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M18 6L6 18M6 6l12 12\"/></svg></button></div><div class=\"kb-cart-drawer__body\"><div id=\"CartDrawerItems\" class=\"kb-cart-drawer__items\"></div></div><div id=\"CartDrawerFooter\" class=\"kb-cart-drawer__footer\"></div><div class=\"kb-cart-drawer__trust\"><div class=\"kb-trust-bar kb-trust-bar--drawer\"><div class=\"kb-trust-bar__item\"><svg width=\"12\" height=\"12\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"1\" y=\"3\" width=\"15\" height=\"13\" rx=\"1\"/><polygon points=\"16 8 20 8 23 11 23 16 16 16 16 8\"/><circle cx=\"5.5\" cy=\"18.5\" r=\"2.5\"/><circle cx=\"18.5\" cy=\"18.5\" r=\"2.5\"/></svg> Free delivery</div><span class=\"kb-trust-bar__sep\"></span><div class=\"kb-trust-bar__item\"><svg width=\"12\" height=\"12\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"23 4 23 10 17 10\"/><path d=\"M20.49 15a9 9 0 11-2.12-9.36L23 10\"/></svg> 30-day returns</div><span class=\"kb-trust-bar__sep\"></span><div class=\"kb-trust-bar__item\"><svg width=\"12\" height=\"12\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\"/><path d=\"M7 11V7a5 5 0 0110 0v4\"/></svg> Secure checkout</div></div></div></div></div>");
      }

      this.el       = document.getElementById('CartDrawer');
      if (!this.el) return;
      this.itemsEl  = document.getElementById('CartDrawerItems');
      this.footerEl = document.getElementById('CartDrawerFooter');
      this.countEl  = this.el.querySelector('.kb-cart-drawer__count');
      this.bindEvents();
    },

    bindEvents() {
      // Overlay and close button
      this.el.querySelector('.kb-cart-drawer__overlay')
        .addEventListener('click', () => this.close());
      this.el.querySelector('.kb-cart-drawer__close')
        .addEventListener('click', () => this.close());

      // Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close();
      });

      // Cart icon in header
      document.querySelectorAll('[data-cart-trigger]').forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });
    },

    async open() {
      this.itemsEl.innerHTML = '<div class="kb-cart-drawer__loading">Loading&hellip;</div>';
      this.el.classList.add('open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.isOpen = true;
      await this.render();
    },

    close() {
      this.el.classList.remove('open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      this.isOpen = false;
    },

    async render() {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        this.renderItems(cart);
        this.renderFooter(cart);
        if (this.countEl) {
          this.countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
        }
        updateCartCount(cart.item_count);
      } catch (err) {
        this.itemsEl.innerHTML = '<div class="kb-cart-drawer__empty"><p>Could not load cart.</p></div>';
      }
    },

    renderItems(cart) {
      if (cart && cart.currency) this.currency = cart.currency;
      if (cart.item_count === 0) {
        this.itemsEl.innerHTML = [
          '<div class="kb-cart-drawer__empty">',
          '<p class="kb-cart-drawer__eyebrow">Nothing here yet</p>',
          '<p style="margin:12px 0 24px;color:var(--kb-text-mid);">Your bag is empty.</p>',
          '<a href="/collections/all" class="kb-btn">Shop the Collection</a>',
          '</div>'
        ].join('');
        return;
      }

      this.itemsEl.innerHTML = cart.items.map(item => [
        '<div class="kb-cart-drawer__item" data-key="' + item.key + '">',
          '<a href="' + item.url + '" class="kb-cart-drawer__item-img">',
            item.image
              ? '<img src="' + item.image + '" alt="' + this.esc(item.title) + '" width="80" height="80" loading="lazy">'
              : '',
          '</a>',
          '<div class="kb-cart-drawer__item-info">',
            '<p class="kb-cart-drawer__item-name">' + this.esc(item.product_title) + '</p>',
            item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="kb-cart-drawer__item-variant">' + this.esc(item.variant_title) + '</p>'
              : '',
            item.properties && item.properties['Pre-Order \u2014 Ships']
              ? '<p class="kb-cart-drawer__preorder"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg> Ships approx. ' + this.esc(item.properties['Pre-Order \u2014 Ships']) + '</p>'
              : '',
            '<div class="kb-cart-drawer__item-qty">',
              '<button class="kb-qty-btn" data-key="' + item.key + '" data-action="minus" aria-label="Decrease quantity">&minus;</button>',
              '<span class="kb-qty-val">' + item.quantity + '</span>',
              '<button class="kb-qty-btn" data-key="' + item.key + '" data-action="plus"  aria-label="Increase quantity">+</button>',
            '</div>',
          '</div>',
          '<div class="kb-cart-drawer__item-price">',
            item.original_line_price !== item.final_line_price
              ? '<s>' + this.money(item.original_line_price) + '</s>' : '',
            '<span>' + this.money(item.final_line_price) + '</span>',
            '<button class="kb-cart-drawer__remove" data-key="' + item.key + '" aria-label="Remove item">',
              '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
            '</button>',
          '</div>',
        '</div>'
      ].join(''));

      this.itemsEl.querySelectorAll('.kb-qty-btn').forEach(btn => {
        btn.addEventListener('click', () => this.changeQty(btn.dataset.key, btn.dataset.action));
      });
      this.itemsEl.querySelectorAll('.kb-cart-drawer__remove').forEach(btn => {
        btn.addEventListener('click', () => this.changeQty(btn.dataset.key, 'remove'));
      });
    },

    freeShippingBar(cart) {
      var threshold = KB_FREE_SHIPPING[this.currency];
      if (!threshold) return '';
      var remaining = threshold - cart.total_price;
      var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      var msg = remaining > 0
        ? 'You&rsquo;re <strong>' + this.money(remaining) + '</strong> away from free delivery'
        : 'Your order qualifies for <strong>free delivery</strong>';
      return [
        '<div class="kb-ship-progress' + (remaining <= 0 ? ' kb-ship-progress--met' : '') + '">',
          '<p class="kb-ship-progress__msg">' + msg + '</p>',
          '<div class="kb-ship-progress__track"><span class="kb-ship-progress__fill" style="width:' + pct + '%"></span></div>',
        '</div>'
      ].join('');
    },

    renderFooter(cart) {
      if (cart && cart.currency) this.currency = cart.currency;
      if (cart.item_count === 0) {
        this.footerEl.innerHTML = '';
        this.el.classList.add('kb-cart-drawer--empty');
        return;
      }
      this.el.classList.remove('kb-cart-drawer--empty');
      this.footerEl.innerHTML = [
        this.freeShippingBar(cart),
        '<div class="kb-cart-drawer__subtotal">',
          '<span>Subtotal</span>',
          '<span>' + this.money(cart.total_price) + '</span>',
        '</div>',
        '<p class="kb-cart-drawer__shipping-note">Shipping &amp; taxes calculated at checkout</p>',
        (document.body.dataset.country && document.body.dataset.country !== 'GB' ? '<p class="kb-cart-drawer__shipping-note">Import duties &amp; taxes may apply, payable on delivery</p>' : ''),
        '<a href="/checkout" class="kb-cart-drawer__checkout">Proceed to Checkout &rarr;</a>',
        '<a href="/cart" class="kb-cart-drawer__view-cart">View full cart</a>'
      ].join('');
    },

    async changeQty(key, action) {
      const itemEl  = this.itemsEl.querySelector('[data-key="' + key + '"]');
      const qtyEl   = itemEl ? itemEl.querySelector('.kb-qty-val') : null;
      const current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      const newQty  = action === 'plus' ? current + 1
                    : action === 'remove' ? 0
                    : Math.max(0, current - 1);

      try {
        const cart = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        }).then(r => r.json());

        this.renderItems(cart);
        this.renderFooter(cart);
        if (this.countEl) {
          this.countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
        }
        updateCartCount(cart.item_count);
      } catch (err) {
        console.error('Cart update error:', err);
      }
    },

    money(cents) {
      return new Intl.NumberFormat(navigator.language || 'en-GB', { style: 'currency', currency: this.currency || 'GBP' }).format(cents / 100);
    },

    esc(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  };

  CartDrawer.init();


})();

/* ============================================================
   HERO SLIDER
   ============================================================ */
var HeroSlider = {

  init: function() {
    var self = this;
    document.querySelectorAll('.kb-hero-slider').forEach(function(el) {
      var count = parseInt(el.dataset.count) || 0;
      if (count < 2) return; // single slide — nothing to do

      var s = {
        el:          el,
        track:       el.querySelector('.kb-hero-slider__track'),
        slides:      el.querySelectorAll('.kb-hero-slider__slide'),
        dots:        el.querySelectorAll('.kb-hero-slider__dot'),
        prevBtn:     el.querySelector('.kb-hero-slider__prev'),
        nextBtn:     el.querySelector('.kb-hero-slider__next'),
        count:       count,
        current:     0,
        autoplay:    el.dataset.autoplay !== 'false',
        speed:       parseInt(el.dataset.speed) || 5000,
        pauseHover:  el.dataset.pauseHover !== 'false',
        timer:       null,
        touchStartX: null,
        reduced:     window.matchMedia('(prefers-reduced-motion: reduce)').matches
      };

      if (s.reduced) s.autoplay = false;

      self._bindEvents(s);
      self._bindVisibility(s);
    });
  },

  _bindEvents: function(s) {
    var self = this;

    /* Dot clicks */
    s.dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        self._goTo(s, parseInt(dot.dataset.index));
        self._resetTimer(s);
      });
    });

    /* Arrow clicks */
    if (s.prevBtn) s.prevBtn.addEventListener('click', function() { self._prev(s); self._resetTimer(s); });
    if (s.nextBtn) s.nextBtn.addEventListener('click', function() { self._next(s); self._resetTimer(s); });

    /* Touch swipe */
    s.el.addEventListener('touchstart', function(e) {
      s.touchStartX = e.touches[0].clientX;
    }, { passive: true });

    s.el.addEventListener('touchend', function(e) {
      if (s.touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - s.touchStartX;
      if (Math.abs(dx) > 48) {
        if (dx < 0) self._next(s); else self._prev(s);
        self._resetTimer(s);
      }
      s.touchStartX = null;
    });

    /* Keyboard (only when slider is in viewport) */
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var r = s.el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      if (e.key === 'ArrowLeft')  { self._prev(s); self._resetTimer(s); }
      if (e.key === 'ArrowRight') { self._next(s); self._resetTimer(s); }
    });

    /* Hover pause / resume */
    if (s.pauseHover) {
      s.el.addEventListener('mouseenter', function() { self._stop(s); });
      s.el.addEventListener('mouseleave', function() { if (s.autoplay) self._start(s); });
    }
  },

  _bindVisibility: function(s) {
    var self = this;
    if (!('IntersectionObserver' in window)) {
      if (s.autoplay) self._start(s);
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if (s.autoplay) self._start(s);
        } else {
          self._stop(s);
        }
      });
    }, { threshold: 0.15 });
    io.observe(s.el);
  },

  _goTo: function(s, idx) {
    s.current = ((idx % s.count) + s.count) % s.count;
    s.track.style.transform = 'translateX(-' + (s.current * 100) + '%)';

    /* Sync dots */
    s.dots.forEach(function(dot, i) {
      var active = i === s.current;
      dot.classList.toggle('active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    /* Accessibility — hide non-active slides from screen readers */
    s.slides.forEach(function(slide, i) {
      slide.setAttribute('aria-hidden', i !== s.current ? 'true' : 'false');
    });
  },

  _next: function(s) { this._goTo(s, s.current + 1); },
  _prev: function(s) { this._goTo(s, s.current - 1); },

  _start: function(s) {
    var self = this;
    self._stop(s);
    s.timer = setInterval(function() { self._next(s); }, s.speed);
  },

  _stop: function(s) {
    if (s.timer) { clearInterval(s.timer); s.timer = null; }
  },

  _resetTimer: function(s) {
    this._stop(s);
    if (s.autoplay) this._start(s);
  }
};

/* Initialise on DOM ready */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { HeroSlider.init(); });
} else {
  HeroSlider.init();
}
